import React, { useEffect, useState } from "react";
import {
  Paper,
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  InputLabel,
Select,
FormControl,
  Tooltip,
  InputAdornment,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  AppBar,
  Toolbar,
  Container,
} from "@mui/material";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { useNavigate, useParams } from "react-router-dom";
import StudentDetailsModal from "./StudentDetailsModal";
import base64 from "base64-js";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Attendance = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [studentDetails, setStudentDetails] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [classList, setClassList] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(1);

  const { encodedFormId } = useParams();
  const navigate = useNavigate();

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") return null;
    try {
      const padded = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(padded);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId }),
      });
      const result = await response.json();
      const data = result[0];
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };

  const handleOpenModal = (student) => {
    setSelectedStudent(student.studentId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedStudent(null);
    setIsModalOpen(false);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleAddAttendance = () => {
    navigate("/addattendance");
  };
  const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};


const fetchClasses = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Attendance/GetClass`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ teacherId: 0 }),
    });
    if (response.ok) {
      const data = await response.json();
      // Ensure data is an array before setting state
      setClassList(Array.isArray(data) ? data : []);
    } else {
      console.error("Failed to fetch classes");
      setClassList([]); // Set to empty array on failure
    }
  } catch (error) {
    console.error("API request error:", error);
    setClassList([]); // Set to empty array on error
  }
};

const fetchStudents = async (classId) => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(`${apiUrl}/Attendance/GetStudentAdmissionDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        classId: classId || 0,
        sessionId: 0,
        branchId: branchId || 0, // Pass branchId in the request body
        stream: "0",
      }),
    });

    if (response.ok) {
      const data = await response.json();
      const validData = Array.isArray(data) ? data : [];
      setStudentDetails(validData);
      setFilteredStudents(validData);
    } else {
      setStudentDetails([]);
      setFilteredStudents([]);
    }
  } catch (error) {
    console.error("API request error:", error);
    setStudentDetails([]);
    setFilteredStudents([]);
  }
};




  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClassId(classId);
    setSearchQuery("");
  };

  // Filter logic with debugging
  useEffect(() => {
    const normalize = (str) =>
      str?.toString().toLowerCase().replaceAll("/", "").trim();

    const trimmedQuery = normalize(searchQuery);

    const filtered = studentDetails.filter((student) => {
      const fieldsToSearch = [
        student?.studentName,
        student?.studentLastName,
        student?.admissionNo,
        student?.rollNo
      ];

      return fieldsToSearch.some((field) =>
        normalize(field).includes(trimmedQuery)
      );
    });

    setFilteredStudents(filtered);
  }, [searchQuery, studentDetails]);

useEffect(() => {
  if (selectedBranchId) {
    fetchStudents(selectedClassId);
  }
}, [selectedBranchId]);

  useEffect(() => {
    if (selectedClassId) fetchStudents(selectedClassId);
  }, [selectedClassId]);

  useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    fetchBranches();
  } else {
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
  }

  fetchClasses();
  fetchStudents();
  Authorizer();
}, []);


  const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(1); // reset to page 1
};

const paginatedData = filteredStudents.slice(
  (page - 1) * rowsPerPage,
  page * rowsPerPage
);


  return (
    <Container>
       <AppBar
  position="static"
  sx={{
    backgroundColor: "#0B1F3D",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
    
    {/* Left: Title */}
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        letterSpacing: "0.5px",
        color: "#ffffff",
      }}
    >
      Student Attendence
    </Typography>

    {/* Right: Branch Dropdown */}
   {isMaster && (
  <Box sx={{ position: "relative" }}>
    <FormControl size="small" sx={{ width: 220 }}>
      <InputLabel
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          top: "-2px",
          "&.Mui-focused": { color: "#64B5F6" },
          "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
        }}
      >
        Branch
      </InputLabel>
      <Select
        value={selectedBranchId || ""}
        onChange={(e) => setSelectedBranchId(e.target.value)}
        label="Branch"
        startAdornment={
          <InputAdornment position="start">
            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
          </InputAdornment>
        }
        sx={{
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.3px",
          backgroundColor: "rgba(255,255,255,0.07)",
          backdropFilter: "blur(8px)",
          borderRadius: "8px",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.15)",
            borderWidth: "1px",
            transition: "border-color 0.2s ease",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.11)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.35)",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.1)",
            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#64B5F6",
              borderWidth: "1.5px",
            },
          },
          "& .MuiSelect-icon": {
            color: "rgba(255,255,255,0.5)",
            transition: "color 0.2s ease",
          },
          "&.Mui-focused .MuiSelect-icon": {
            color: "#64B5F6",
          },
          "& .MuiSelect-select": {
            py: 1.1,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "10px",
              border: "1px solid rgba(11,31,61,0.12)",
              boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.5 },
            },
          },
        }}
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.branchId}
            value={branch.branchId}
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#0B1F3D",
              px: 2,
              py: 1.1,
              mx: 0.5,
              borderRadius: "6px",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "rgba(11,31,61,0.07)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(25,118,210,0.1)",
                color: "#1565C0",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(25,118,210,0.15)",
                },
              },
            }}  
          >
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
)}
  </Toolbar>
</AppBar>
      <Paper
        style={{ padding: "20px", maxWidth: "1200px", margin: "auto", marginTop: "5px" }}
        elevation={4}
      >
       
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
  <Grid item xs={12} sm={9}>
    <Grid container spacing={2}>
       <Grid item xs={12} sm={6} md={5}>
        <TextField
          label="Search by Name or Admission No"
          variant="outlined"
          fullWidth
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Enter name, admission no, or roll no..."
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
     
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          select
          label="Class"
          variant="outlined"
          fullWidth
          value={selectedClassId}
          onChange={handleClassChange}
        >
          {Array.isArray(classList) && classList.map((classItem) => (
            <MenuItem key={classItem.classId} value={classItem.classId}>
              {classItem.className}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  </Grid>
  <Grid item xs={12} sm={3} sx={{ textAlign: { xs: "center", sm: "right" } }}>
    <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow>
      <span>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddAttendance}
          style={{
            width: "160px",
            height: "50px",
            padding: "10px 0",
            fontWeight: "bold",
          }}
          disabled={!canAdd}
        >
          Add Attendance
        </Button>
      </span>
    </Tooltip>
  </Grid>
</Grid>
       

        <TableContainer
          component={Paper}
          style={{ marginTop: 16 }}
        >
          <Table

            sx={{
              minWidth: 650,
              border: "1px solid #ccc",
              "& .MuiTableCell-root": {
                borderRight: "1px solid #ccc",
                fontSize: "1rem",
              },
              "& .MuiTableHead-root .MuiTableCell-root": {
                fontWeight: "bold",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <TableHead>
              <TableRow>
                {["Serial No", "Admission No", "First Name", "Last Name", "Father's Name", "Roll No", "Stream", "Action"].map(
                  (label) => (
                    <TableCell
                      key={label}
                      sx={{ borderRight: "1px solid #ccc", fontWeight: "bold", fontSize: "1.1rem" }}
                    >
                      {label}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.length > 0 ? (
                paginatedData.map((student, index) => (
                  <TableRow key={student.studentId} sx={{ borderTop: "1px solid #ccc" }}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{student.admissionNo || "N/A"}</TableCell>
                    <TableCell>{student.studentName || "N/A"}</TableCell>
                    <TableCell>{student.studentLastName || "N/A"}</TableCell>
                    <TableCell>{student.fathersName || "N/A"}</TableCell>
                    <TableCell>{student.rollNo || "N/A"}</TableCell>
                    <TableCell>{student.stream || "N/A"}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <IconButton color="primary" onClick={() => handleOpenModal(student)}>
                        <BadgeOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ fontSize: "1.1rem", py: 3 }}>
                    {searchQuery.trim()
                      ? "No matching students found"
                      : studentDetails.length === 0
                        ? "No students available"
                        : "Please select a class to view students"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {filteredStudents.length > 0 && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
    <TextField
      select
      label="Rows per page"
      value={rowsPerPage}
      onChange={handleChangeRowsPerPage}
      sx={{ width: 150 }}
      SelectProps={{
        native: true,
      }}
    >
      {rowsPerPageOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </TextField>

    <Box>
      <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
        Page {page} of {Math.ceil(filteredStudents.length / rowsPerPage)}
      </Typography>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page - 1)}
        disabled={page === 1}
        sx={{ mr: 1 }}
      >
        Prev
      </Button>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page + 1)}
        disabled={page >= Math.ceil(filteredStudents.length / rowsPerPage)}
      >
        Next
      </Button>
    </Box>
  </Box>
)}

      </Paper>

      <StudentDetailsModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        studentId={selectedStudent}
      />
    </Container>
  );
};

export default Attendance;